<template>
    <div class="popMenu" v-if="isActive && menus.length > 0" :class="isShow && `show`">
        <div class="popMenu-content">
            <div class="popMenu-main">

                <div class="popMenu-header">
                    <h2 class="popMenu-headerText">{{ $t('menu') }}</h2>
                    <button tabindex="-1" type="button" class="popMenu-buttonClose" @click="close"><span
                            class="material-symbols-outlined">close</span></button>
                </div>

                <div class="popMenu-body">
                    <ul class="menus">
                        <li class="menu-item" v-for="(item, index) in menus" :key="index">
                            <a v-if="item.externalLink" target="_blank" :href="item.externalLink" class="menu-link">
                                <span class="menu-text">{{ item.title }}</span>
                                <span class="menu-arrow material-symbols-outlined">call_made</span>
                            </a>
                            <a v-else :href="item.uri" class="menu-link">
                                <span class="menu-text">{{ item.title }}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props: ['menus'],
    name: 'PopMenu',

    computed: {
        isPopMenu() {
            return this.$store.getters.popMenu
        },
    },
    watch: {
        isPopMenu(val) {
            if (val) {
                this.showHandle()
            }
            else {
                this.hideHandle()
            }
        },
    },
    data() {
        return {
            isActive: false,
            isShow: false,
        }
    },

    methods: {
        close() {
            this.$store.dispatch('popMenu', false)
        },

        showHandle() {
            this.isActive = true
        },

        hideHandle() {
            this.isActive = false
        }
    }
}
</script>

<style lang="scss" scoped>
.popMenu {
    display: flex;
    position: fixed;

    z-index: 1200;
    flex-direction: unset;
    inset: 0px;
    background-color: rgba(0, 0, 0, 0.5);

}

.popMenu-content {
    box-sizing: border-box;

    box-shadow: rgb(20 21 26 / 16%) 0px 8px 16px, rgb(71 77 87 / 16%) 0px 16px 32px, rgb(20 21 26 / 10%) 0px 0px 1px;
    background-color: #fff;

    // transform: translateY(-100%);
    animation: 0.3s ease-in-out 0s 1 normal none running animation-up;
    width: 100%;


    position: absolute;
    height: 80vh;
    bottom: 0;
    left: 0;
}

.popMenu-main {
    display: flex;
    flex-direction: column;
}

@keyframes animation-popMenuContent {
    0% {
        transform: scale(0.95);
    }

    66% {
        transform: scale(1.05);
    }

    100% {
        transform: scale(1);
    }
}

@keyframes animation-up {
    0% {
        transform: translateY(100%)
    }

    66% {
        transform: translateY(-1%)
    }

    100% {
        transform: translateY(0)
    }
}


.popMenu-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 12px 12px 8px 24px;
    border-bottom: 1px solid #ddd;
}

.popMenu-headerText {
    margin-bottom: 0;
    font-size: 32px;
}

.popMenu-buttonClose {
    width: 38px;
    height: 38px;

    background-color: transparent;
    border: none;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background-color: #f2f2f2;
    }
}

.menus {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0;

    padding-bottom: 15px;

    // box-sizing: border-box;
    // min-width: 0px;
    // max-height: 320px;
    // overflow-y: auto;

    // &::-webkit-scrollbar {
    //     border-radius: 6px;
    // }

    // &::-webkit-scrollbar {
    //     width: 8px;
    //     height: 10px;
    //     background-color: rgb(30, 35, 41);
    // }
}

.menu-item {
    display: block;
    padding: 0;
    margin: 0;


}

.menu-item+.menu-item {

    border-top: 1px solid rgb(241, 241, 241);
}

.menu-link {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #101011;

    text-decoration: none;
    padding: 8px 24px;

    &:hover {
        // background-color: #f2f2f2;
        color: #712d7d;
    }

    .menu-arrow {
        font-size: 18px;
    }
}


@media (min-width: 600px) {
    .popMenu {
        align-items: center;
        justify-content: center;
    }

    .popMenu-content {
        animation: 0.3s ease-in-out 0s 1 normal none running animation-popMenuContent;
        height: auto;
        transform: translateY(0);

        position: relative;
        bottom: auto;
        left: auto;
        max-width: 450px;
    }
}
</style>